// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only percy {
  .hide-in-percy {
    visibility: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@signavio/ui/assets/percy.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@media only percy {\n  .hide-in-percy {\n    visibility: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
